const DEFAULT_RATING = '0'
const DEFAULT_DIAGNOSIS = 'A000 - Cholera due to Vibrio cholerae 01, biovar cholerae'

export const START_DATE_PLACEHOLDER = 'Start Date Placeholder'
export const END_DATE_PLACEHOLDER = 'End Date Placeholder'

export const defaultDiagnosisInfo = [
  DEFAULT_DIAGNOSIS,
  DEFAULT_RATING,
  START_DATE_PLACEHOLDER,
  END_DATE_PLACEHOLDER
]
